import {Pagination as PeacockPagination} from '@pepsico-ds/ui'

/** @typedef {import('@pepsico-ds/ui').IPaginationProps} PaginationProps */

/** Wrapper around Peacock DS Pagination. @param {PaginationProps} props */
export const Pagination = props => <PeacockPagination {...props} />
